import { contentStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsContent";
import { css } from "styled-components";

contentStyles.container = {
    css: css`
        margin: 0;
    `,
};
